<p-toast></p-toast>

<div
  class="container"
  *ngIf="searched && data && data.length > 0; else noResultsFound"
>
  <div class="styled-text-wrapper">
    <span class="styled-text">{{ searchQueryGrid }}</span>
  </div>
  <div class="main-content" *ngFor="let item of data; let i = index">
    <div class="card">
      <div *ngIf="i % 1 === 0" class="route-label-container">
        <div class="line"></div>
        <div class="route-label">
          Impurity
          {{
            currentPage_technical === 1
              ? i + 1
              : (currentPage_technical - 1) * (currentRow_technical || 15) +
                i +
                1
          }}
        </div>

        <div class="line"></div>
      </div>
      <section class="product-info" id="productinfo">
        <h4
          style="
            font-weight: 800;
            font-size: 20px;
            color: #ff5a5a;
            margin-bottom: 20px;
            text-align: left;
            background: #ff5a5a;
            -webkit-background-clip: text;
            color: transparent;
            text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1),
              -2px -2px 5px rgba(0, 0, 0, 0.1);
            letter-spacing: 1px;
            transition: color 0.3s ease, text-shadow 0.3s ease;
          "
        >
          {{ item.impurity_name || " Impurity Related Literature " }}
          <button
            class="copy-btn"
            *ngIf="item.impurity_name"
            (click)="copyToClipboard(item.impurity_name)"
            pTooltip="Copy to clipboard"
            tooltipPosition="top"
          >
            <i class="pi pi-copy"></i>
          </button>
        </h4>
        <!-- Chemical Structure Image -->
        <div class="product-container2">
          <!-- Left Side: Chemical Structure -->
          <div
            class="chemical-structure2"
            *ngIf="displayMap['chemicalStructure'] && item.chemicalStructure"
          >
            <!-- <h2>Chemical Structure</h2> -->
            <div class="image-container2">
              <img
                class="inventor-logo"
                *ngIf="item.chemicalStructure"
                [src]="
                  'https://www.chemrobotics.com/agropat/images/chemical_directory_structures/' +
                  (item.chemicalStructure.endsWith('.svg') ||
                  item.chemicalStructure.endsWith('.jpg') ||
                  item.chemicalStructure.endsWith('.jpeg') ||
                  item.chemicalStructure.endsWith('.webp')
                    ? item.chemicalStructure
                    : item.chemicalStructure + '.png')
                "
                alt="Inventor Logo"
              />
            </div>
            <button class="view-btn2" (click)="ImageFullView(item)">
              <i class="pi pi-search"></i>
            </button>
          </div>

          <!-- Bootstrap Modal for Full Image View -->
          <div
            class="modal fade"
            id="imageModal"
            tabindex="-1"
            aria-labelledby="imageModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="imageModalLabel">
                    Chemical Structure
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body text-center">
                  <!-- Ensures content inside is centered -->
                  <img
                    *ngIf="fullImageUrl"
                    [src]="fullImageUrl"
                    alt="Chemical Structure"
                    class="img-fluid w-100"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- Right Side: Product Information -->
          <div class="product-info-container2">
            <div class="grid grid-cols-3" style="margin-top: -20px">
              <div
                class="product-info2"
                *ngIf="displayMap['gbrn'] && item.gbrn"
              >
                <h6>
                  GBRN
                  <button
                    class="copy-btn2"
                    (click)="copyToClipboardFormattedDate(item.gbrn)"
                    pTooltip="Copy to clipboard"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>
                <p style="overflow-y: auto">
                  {{ item.gbrn }}
                </p>
              </div>
              <div
                class="product-info2"
                *ngIf="displayMap['impurity_name'] && item.impurity_name"
              >
                <h6>
                  IMPUITY NAME

                  <button
                    class="copy-btn2"
                    (click)="copyToClipboard(item.impurity_name)"
                    pTooltip="Copy to clipboard"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>

                <p>
                  {{ item.impurity_name || "-" }}
                </p>
              </div>
              <div
                class="product-info2"
                *ngIf="
                  displayMap['molecular_formula'] && item.molecular_formula
                "
              >
                <h6>
                  Molecular Formula
                  <button
                    class="copy-btn2"
                    *ngIf="item.molecular_formula"
                    (click)="copyToClipboard(item.molecular_formula)"
                    pTooltip="Copy to clipboard"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>
                <p>
                  {{ item.molecular_formula || "-" }}
                </p>
              </div>
              <div
                class="product-info2"
                *ngIf="displayMap['casRn'] && item.casRn"
              >
                <h6>
                  CAS RN
                  <button
                    class="copy-btn2"
                    *ngIf="item.casRn"
                    (click)="copyToClipboard(item.casRn)"
                    pTooltip="Copy to clipboard"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>
                <p>
                  {{ item.casRn || "-" }}
                </p>
              </div>
              <div
                class="product-info2"
                *ngIf="displayMap['category'] && item.category"
              >
                <h6>
                  category
                  <button
                    class="copy-btn2"
                    *ngIf="item.category"
                    (click)="copyToClipboard(item.category)"
                    pTooltip="Copy to clipboard"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>

                <p>
                  {{ item.category || "-" }}
                </p>
              </div>
              <div
                class="product-info2"
                *ngIf="displayMap['formula_weight'] && item.formula_weight"
              >
                <h6>
                  Formula Weight
                  <button
                    class="copy-btn2"
                    (click)="copyToClipboard(item.formula_weight)"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>
                <p>{{ item.formula_weight || "-" }}</p>
              </div>
              <div
                class="product-info2"
                *ngIf="displayMap['pubchemId'] && item.pubchemId"
              >
                <h6>
                  PUBCHEM CID:
                  <button
                    class="copy-btn"
                    *ngIf="item.pubchemId"
                    (click)="copyToClipboard(item.pubchemId)"
                    pTooltip="Copy to clipboard"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>

                <a
                  style="
                    margin: 5px;
                    padding: 10px;
                    background: #ff5a5a;
                    color: rgb(255 237 141);
                    text-decoration: none;
                    border-radius: 5px;
                    cursor: pointer;
                    display: inline-block;
                  "
                  target="_blank"
                  [href]="
                    'https://pubchem.ncbi.nlm.nih.gov/compound/' +
                    item.pubchemId
                  "
                >
                  {{ item.pubchemId || "-" }}
                </a>
              </div>
              <div
                class="product-info2"
                *ngIf="displayMap['chemicalClass'] && item.chemicalClass"
              >
                <h6>
                  chemical class
                  <button
                    class="copy-btn"
                    *ngIf="item.chemicalClass"
                    (click)="copyToClipboard(item.chemicalClass)"
                    pTooltip="Copy to clipboard"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>
                <p>
                  {{ item.chemicalClass || "-" }}
                </p>
              </div>
              <div
                class="product-info2"
                *ngIf="displayMap['iupac'] && item.iupac"
              >
                <h6>
                  iupac
                  <button
                    class="copy-btn"
                    *ngIf="item.iupac"
                    (click)="copyToClipboard(item.iupac)"
                    pTooltip="Copy to clipboard"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>
                <p>
                  {{ item.iupac || "-" }}
                </p>
              </div>
              <div
                class="product-info2"
                *ngIf="displayMap['chemical_name'] && item.chemical_name"
              >
                <h6>
                  chemical name
                  <button
                    class="copy-btn2"
                    (click)="copyToClipboard(item.chemical_name)"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </h6>
                <p>{{ item.chemical_name || "-" }}</p>
              </div>
              <!-- <div class="product-info2" *ngIf="item.formula_weight">
              <h6>
                Formula Weight
                <button
                  class="copy-btn2"
                  *ngIf="item.formula_weight"
                  (click)="copyToClipboard(item.formula_weight)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>{{ item.formula_weight || "-" }}</p>
              <div class="logos-images">
                <img
                  style="width: 100px"
                  *ngIf="item.companyLogo; else placeholder"
                  [src]="
                    'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                    item.companyLogo
                  "
                  alt="Inventor Logo"
                  class="inventor-logo"
                  (error)="onImageError($event)"
                />
                <ng-template #placeholder>
                  <span style="width: 300px; display: inline-block"
                    >INVENTOR LOGO</span
                  >
                </ng-template>
              </div>
            </div> -->
            </div>
          </div>
        </div>

        <!-- Bootstrap Modal for Full Image View -->
        <p-galleria
          [value]="galleriaImages"
          [(visible)]="displayGalleria"
          [containerStyle]="{ 'max-width': '100%' }"
          [numVisible]="1"
          [circular]="true"
          [fullScreen]="true"
          [showItemNavigators]="false"
          [showThumbnails]="false"
        >
          <ng-template pTemplate="item" let-item>
            <!-- Modal Background (Click to Close) -->
            <div class="modal-overlay" (click)="closeGalleria($event)">
              <div class="image-wrapper" (click)="$event.stopPropagation()">
                <!-- Zoom Controls Positioned at the Top Right -->
                <div class="zoom-controls">
                  <button (click)="zoomIn($event)" title="Zoom In">
                    <i class="pi pi-search-plus"></i>
                  </button>
                  <button (click)="zoomOut($event)" title="Zoom Out">
                    <i class="pi pi-search-minus"></i>
                  </button>
                  <button class="close-button" (click)="closeGalleria($event)">
                    ×
                  </button>
                </div>

                <!-- Scrollable Image Container -->
                <div class="zoom-container">
                  <img
                    [src]="item.itemImageSrc"
                    [style.transform]="'scale(' + zoomLevel + ')'"
                    class="zoomable-image"
                  />
                </div>
              </div>
            </div>
          </ng-template>
        </p-galleria>

        <div class="logos" id="contentToExport3">
          <!-- <h3 class="logos-title">Innovators' Logos</h3> -->
          <!-- Title remains above images -->
          <!-- inventorLogo -->

          <!-- <div class="result-header">
      <h6 style="margin-top: 8px">
        {{ item.companyLogo || "-" }}
      </h6>
    </div> -->
        </div>

        <!-- <div class="product-detail" id="contentToExport1">
          <div class="grid grid-cols-3" style="margin-top: -20px">
            
          </div>
        </div> -->
        <!-- <br /> -->

        <div class="product-additional-details">
          <!-- First Section Wrapper -->
          <div class="section-wrapper" id="description">
            <hr class="section-divider" />
            <h2 class="section-title">
              Impurity description
              <!-- <button
                class="copy-btn"
                *ngIf="item.description"
                (click)="copyToClipboard(item.description)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
                style="color: #ffe16a"
              >
                <i class="pi pi-copy"></i>
              </button> -->
            </h2>
            <!-- <p>
              {{ item.description }}
            </p> -->
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-4">
                <div
                  *ngIf="displayMap['description'] && item.description"
                  class="product-info"
                >
                  <h6>
                    description
                    <button
                      class="copy-btn"
                      *ngIf="item.description"
                      (click)="copyToClipboard(item.description)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p style="overflow-y: auto; max-height: 150px">
                    {{ item.description }}
                  </p>
                </div>

                <div
                  *ngIf="displayMap['trrn'] && item.trrn"
                  class="product-info"
                >
                  <h6>
                    trrn
                    <button
                      class="copy-btn"
                      *ngIf="item.trrn"
                      (click)="copyToClipboard(item.trrn)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.trrn }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['cmrn'] && item.cmrn"
                  class="product-info"
                >
                  <h6>
                    cmrn
                    <button
                      class="copy-btn"
                      *ngIf="item.cmrn"
                      (click)="copyToClipboard(item.cmrn)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.cmrn }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['cvrn'] && item.cvrn"
                  class="product-info"
                >
                  <h6>
                    cvrn
                    <button
                      class="copy-btn"
                      *ngIf="item.cvrn"
                      (click)="copyToClipboard(item.cvrn)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.cvrn }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['cprn'] && item.cprn"
                  class="product-info"
                >
                  <h6>
                    cprn
                    <button
                      class="copy-btn"
                      *ngIf="item.cprn"
                      (click)="copyToClipboard(item.cprn)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.cprn }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['name'] && item.name"
                  class="product-info"
                >
                  <h6>
                    name
                    <button
                      class="copy-btn"
                      *ngIf="item.name"
                      (click)="copyToClipboard(item.name)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.name }}
                  </p>
                </div>

                <div
                  *ngIf="displayMap['cat_no'] && item.cat_no"
                  class="product-info"
                >
                  <h6>
                    cat no
                    <button
                      class="copy-btn"
                      *ngIf="item.cat_no"
                      (click)="copyToClipboard(item.cat_no)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.cat_no }}
                  </p>
                </div>

                <div
                  *ngIf="
                    displayMap['synonyms_common_name'] &&
                    item.synonyms_common_name
                  "
                  class="product-info"
                >
                  <h6>
                    synonyms common name
                    <button
                      class="copy-btn"
                      *ngIf="item.synonyms_common_name"
                      (click)="copyToClipboard(item.synonyms_common_name)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.synonyms_common_name }}
                  </p>
                </div>

                <div
                  *ngIf="displayMap['chemicalClass'] && item.chemicalClass"
                  class="product-info"
                >
                  <h6>
                    chemical class
                    <button
                      class="copy-btn"
                      *ngIf="item.chemicalClass"
                      (click)="copyToClipboard(item.chemicalClass)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.chemicalClass }}
                  </p>
                </div>

                <div
                  *ngIf="displayMap['substanceOrigin'] && item.substanceOrigin"
                  class="product-info"
                >
                  <h6>
                    substance origin
                    <button
                      class="copy-btn"
                      *ngIf="item.substanceOrigin"
                      (click)="copyToClipboard(item.substanceOrigin)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.substanceOrigin }}
                  </p>
                </div>
                <div
                  *ngIf="item.trage_name_proprietary_name"
                  class="product-info"
                >
                  <h6>
                    trage_name_proprietary_name
                    <button
                      class="copy-btn"
                      *ngIf="item.trage_name_proprietary_name"
                      (click)="
                        copyToClipboard(item.trage_name_proprietary_name)
                      "
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.trage_name_proprietary_name }}
                  </p>
                </div>
                <div
                  *ngIf="
                    displayMap['related_compounds'] && item.related_compounds
                  "
                  class="product-info"
                >
                  <h6>
                    related compounds
                    <button
                      class="copy-btn"
                      *ngIf="item.related_compounds"
                      (click)="copyToClipboard(item.related_compounds)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.related_compounds }}
                  </p>
                </div>
                <div
                  class="product-info"
                  *ngIf="displayMap['pubchemId'] && item.pubchemId"
                >
                  <h6>
                    PUBCHEM CID:
                    <button
                      class="copy-btn"
                      *ngIf="item.pubchemId"
                      (click)="copyToClipboard(item.pubchemId)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <a
                    style="
                      margin: 5px;
                      padding: 10px;
                      background: #ff5a5a;
                      color: rgb(255 237 141);
                      text-decoration: none;
                      border-radius: 5px;
                      cursor: pointer;
                      display: inline-block;
                    "
                    target="_blank"
                    [href]="
                      'https://pubchem.ncbi.nlm.nih.gov/compound/' +
                      item.pubchemId
                    "
                  >
                    {{ item.pubchemId || "-" }}
                  </a>
                </div>
                <div
                  *ngIf="displayMap['ecNo'] && item.ecNo"
                  class="product-info"
                >
                  <h6>
                    ec no
                    <button
                      class="copy-btn"
                      *ngIf="item.ecNo"
                      (click)="copyToClipboard(item.ecNo)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.ecNo }}
                  </p>
                </div>
                <div
                  *ngIf="
                    displayMap['usEpaChemicalCode'] && item.usEpaChemicalCode
                  "
                  class="product-info"
                >
                  <h6>
                    us epa chemical code
                    <button
                      class="copy-btn"
                      *ngIf="item.usEpaChemicalCode"
                      (click)="copyToClipboard(item.usEpaChemicalCode)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.usEpaChemicalCode }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['unii'] && item.unii"
                  class="product-info"
                >
                  <h6>
                    unii
                    <button
                      class="copy-btn"
                      *ngIf="item.unii"
                      (click)="copyToClipboard(item.unii)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.unii }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['unNumber'] && item.unNumber"
                  class="product-info"
                >
                  <h6>
                    un number
                    <button
                      class="copy-btn"
                      *ngIf="item.unNumber"
                      (click)="copyToClipboard(item.unNumber)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.unNumber }}
                  </p>
                </div>
                <div *ngIf="displayMap['atc'] && item.atc" class="product-info">
                  <h6>
                    atc
                    <button
                      class="copy-btn"
                      *ngIf="item.atc"
                      (click)="copyToClipboard(item.atc)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.atc }}
                  </p>
                </div>
                <div
                  *ngIf="
                    displayMap['dsstox_substance_id'] &&
                    item.dsstox_substance_id
                  "
                  class="product-info"
                >
                  <h6>
                    dsstox substance id
                    <button
                      class="copy-btn"
                      *ngIf="item.dsstox_substance_id"
                      (click)="copyToClipboard(item.dsstox_substance_id)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dsstox_substance_id }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['other_codes'] && item.other_codes"
                  class="product-info"
                >
                  <h6>
                    other codes
                    <button
                      class="copy-btn"
                      *ngIf="item.other_codes"
                      (click)="copyToClipboard(item.other_codes)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.other_codes }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['packSize'] && item.packSize"
                  class="product-info"
                >
                  <h6>
                    pack size
                    <button
                      class="copy-btn"
                      *ngIf="item.packSize"
                      (click)="copyToClipboard(item.packSize)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.packSize }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['commentry'] && item?.commentry"
                  class="product-info"
                >
                  <h6>
                    commentry
                    <button
                      class="copy-btn"
                      *ngIf="item?.commentry"
                      (click)="copyToClipboard(item?.commentry)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item?.commentry }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['notes'] && item.notes"
                  class="product-info"
                >
                  <h6>
                    notes
                    <button
                      class="copy-btn"
                      *ngIf="item.notes"
                      (click)="copyToClipboard(item.notes)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.notes }}
                  </p>
                </div>
                <div
                  *ngIf="displayMap['remarks'] && item.remarks"
                  class="product-info"
                >
                  <h6>
                    remarks
                    <button
                      class="copy-btn"
                      *ngIf="item.remarks"
                      (click)="copyToClipboard(item.remarks)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.remarks }}
                  </p>
                </div>
                <div
                  *ngIf="
                    displayMap['literature_reference'] &&
                    item.literature_reference
                  "
                  class="product-info"
                >
                  <h6>
                    literature reference
                    <button
                      class="copy-btn"
                      *ngIf="item.literature_reference"
                      (click)="copyToClipboard(item.literature_reference)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.literature_reference }}
                  </p>
                </div>
                <div
                  *ngIf="
                    displayMap['informationSources'] && item.informationSources
                  "
                  class="product-info"
                >
                  <h6>
                    Information Sources
                    <button
                      class="copy-btn"
                      (click)="copyToClipboard(item.informationSources)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    <a
                      [href]="item.informationSources"
                      target="_blank"
                      rel="noopener noreferrer"
                      style="
                        margin: 5px;
                        padding: 10px;
                        background: #ff5a5a;
                        color: rgb(255 237 141);
                        text-decoration: none;
                        border-radius: 5px;
                        cursor: pointer;
                        display: inline-block;
                      "
                    >
                      {{ item.informationSources }}
                    </a>
                  </p>
                </div>

                <div
                  *ngIf="
                    displayMap['structure_elucidation_report'] &&
                    item.structure_elucidation_report
                  "
                  class="product-info"
                >
                  <h6>
                    structure elucidation report
                    <button
                      class="copy-btn"
                      *ngIf="item.structure_elucidation_report"
                      (click)="
                        copyToClipboard(item.structure_elucidation_report)
                      "
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.structure_elucidation_report }}
                  </p>
                </div>
                <div
                  class="product-info"
                  *ngIf="displayMap['pdfMultiplePdf'] && item.pdfMultiplePdf"
                >
                  <h6>
                    pdf multiple pdf
                    <button
                      class="copy-btn"
                      *ngIf="item.pdfMultiplePdf"
                      (click)="copyToClipboard(item.pdfMultiplePdf)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <a
                    style="
                      margin: 5px;
                      padding: 10px;
                      background: #ff5a5a;
                      color: rgb(255 237 141);
                      text-decoration: none;
                      border-radius: 5px;
                      cursor: pointer;
                      display: block;
                    "
                    target="_blank"
                    [href]="getCleanPdfUrl(item.pdfMultiplePdf)"
                  >
                    {{ getCleanPdfUrl(item.pdfMultiplePdf) || "-" }}
                  </a>
                </div>

                <div *ngIf="displayMap['coa'] && item.coa" class="product-info">
                  <h6>
                    coa
                    <button
                      class="copy-btn"
                      *ngIf="item.coa"
                      (click)="copyToClipboard(item.coa)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.coa }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              item.dummy1 ||
              item.dummy2 ||
              item.dummy3 ||
              item.dummy4 ||
              item.dummy5 ||
              item.dummy6 ||
              item.dummy7 ||
              item.dummy8 ||
              item.dummy9 ||
              item.dummy10 ||
              item.dummy11 ||
              item.dummy12 ||
              item.dummy13 ||
              item.dummy14
            "
            class="section-wrapper"
            id="dummy"
          >
            <hr class="section-divider" />
            <h2 class="section-title">DUMMY</h2>
            <div class="product-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-2">
                <div
                  *ngIf="displayMap['dummy1'] && item.dummy1"
                  class="product-info"
                >
                  <h6>
                    DUMMY 1
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy1"
                      (click)="copyToClipboard(item.dummy1)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy1 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy1 || '-')"></p> -->
                </div>

                <div
                  *ngIf="displayMap['dummy2'] && item.dummy2"
                  class="product-info"
                >
                  <h6>
                    DUMMY 2
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy2"
                      (click)="copyToClipboard(item.dummy2)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy2 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy2 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy3'] && item.dummy3"
                  class="product-info"
                >
                  <h6>
                    DUMMY 3
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy3"
                      (click)="copyToClipboard(item.dummy3)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy3 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy3 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy4'] && item.dummy4"
                  class="product-info"
                >
                  <h6>
                    DUMMY 4
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy4"
                      (click)="copyToClipboard(item.dummy4)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy4 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy4 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy5'] && item.dummy5"
                  class="product-info"
                >
                  <h6>
                    DUMMY 5
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy5"
                      (click)="copyToClipboard(item.dummy5)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy5 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy5 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy6'] && item.dummy6"
                  class="product-info"
                >
                  <h6>
                    DUMMY 6
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy6"
                      (click)="copyToClipboard(item.dummy6)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy6 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy6 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy7'] && item.dummy7"
                  class="product-info"
                >
                  <h6>
                    DUMMY 7
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy7"
                      (click)="copyToClipboard(item.dummy7)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy7 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy7 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy8'] && item.dummy8"
                  class="product-info"
                >
                  <h6>
                    DUMMY 8
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy1"
                      (click)="copyToClipboard(item.dummy1)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy8 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy8 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy9'] && item.dummy9"
                  class="product-info"
                >
                  <h6>
                    DUMMY 9
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy9"
                      (click)="copyToClipboard(item.dummy9)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy9 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy9 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy10'] && item.dummy10"
                  class="product-info"
                >
                  <h6>
                    DUMMY 10
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy10"
                      (click)="copyToClipboard(item.dummy10)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy10 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy10 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy11'] && item.dummy11"
                  class="product-info"
                >
                  <h6>
                    DUMMY 11
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy11"
                      (click)="copyToClipboard(item.dummy11)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy11 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy11 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy12'] && item.dummy12"
                  class="product-info"
                >
                  <h6>
                    DUMMY 12
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy12"
                      (click)="copyToClipboard(item.dummy12)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy12 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy12 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy13'] && item.dummy13"
                  class="product-info"
                >
                  <h6>
                    DUMMY 13
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy13"
                      (click)="copyToClipboard(item.dummy13)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy13 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy13 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy14'] && item.dummy14"
                  class="product-info"
                >
                  <h6>
                    DUMMY 14
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy14"
                      (click)="copyToClipboard(item.dummy14)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy14 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy14 || '-')"></p> -->
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>
        </div>
      </section>
      <!-- <button
        class="read-more-btn"
        *ngIf="hasExpandableContent(item)"
        (click)="toggleCard(i)"
      >
        {{ expandedCards[i] ? "Read Less" : "Read More" }}
      </button> -->
    </div>

    <!-- Sidebar -->
    <aside class="sidebar" *ngIf="i == 0">
      <div
        style="
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
        "
      >
        <!-- Left side: Total Records -->
        <div style="width: 50%">
          <strong
            style="
              background: #ff5a5a;
              color: #ffed8d;
              font-size: 16px;
              font-weight: 700;
              padding: 11px 15px;
              border-radius: 12px;
              box-shadow: 0 2px 4px #0003;
              white-space: nowrap;
              display: block;
              width: fit-content;
            "
          >
            Total Records: {{ totalRecords }}
          </strong>
        </div>

        <!-- Right side: Buttons -->
        <div
          style="
            width: 50%;
            display: flex;
            justify-content: flex-end;
            margin-left: 50px;
          "
        >
          <button
            style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
              margin-right: 10px;
            "
            (click)="exportExcel('csv')"
          >
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">CSV</span>
          </button>
          <button
            style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
            "
            (click)="exportExcel('xlsx')"
          >
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">XLS</span>
          </button>
        </div>
      </div>

      <h3 class="sidebar-title">
        Filters
        <button class="sidebar-toggle" (click)="toggleSidebar()">
          <span *ngIf="!isSidebarOpen">☰</span>
          <span *ngIf="isSidebarOpen">×</span>
        </button>
      </h3>

      <ul [class.active]="isSidebarOpen">
        <li>
          <label for="categoryFilter">CATEGORY</label>
          <p-dropdown
            [options]="categoryOptions"
            [filter]="true"
            filterPlaceholder="Search Category"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.category"
            (onChange)="createFilter('category', $event.value)"
            placeholder="Select Category"
          ></p-dropdown>
        </li>

        <!-- <li>
          <label for="categoryFilter">PATENT TYPE</label>
          <p-dropdown
            [options]="patentTypeOptions"
            [filter]="true"
            filterPlaceholder="Search Patent Type "
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.patentType"
            (onChange)="createFilter('patentType', $event.value)"
            placeholder="Select Patent Type "
          ></p-dropdown>
        </li>

        <li>
          <label for="categoryFilter">ASSIGNEE</label>
          <p-dropdown
            [options]="assigneeOptions"
            [filter]="true"
            filterPlaceholder="Search Assignee"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.assignee"
            (onChange)="createFilter('assignee', $event.value)"
            placeholder="Select Assignee"
          ></p-dropdown>
        </li> -->

        <!-- <li>
          <label for="categoryFilter">APPLICATION OF INTER</label>
          <p-dropdown
            [options]="PlatformFliters.activeIngredient"
            [filter]="true"
            filterPlaceholder="Search Application Of Inter"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.activeIngredient"
            (onChange)="createFilter('activeIngredient', $event.value)"
            placeholder="Select Application Of Inter"
          ></p-dropdown>
        </li> -->

        <!-- <li>
          <label for="categoryFilter">FEILD OF APPLICATION</label>
          <p-dropdown
            [options]="PlatformFliters.fieldOfApplication"
            [filter]="true"
            filterPlaceholder="Search Feild Of Application"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.fieldOfApplication"
            (onChange)="createFilter('fieldOfApplication', $event.value)"
            placeholder="Select Feild Of Application"
          ></p-dropdown>
        </li> -->

        <!-- <li>
          <label for="colorFilter">ORDER</label>

          <p-dropdown
            [options]="sortByOptions"
            [filter]="true"
            filterPlaceholder="Search Order"
            filterBy="name"
            class="w-full custom-dropdown"
            [(ngModel)]="sortBy"
            (onChange)="applyFilter()"
            optionLabel="name"
            optionValue="code"
            placeholder="Select Order"
          >
          </p-dropdown>
        </li> -->
        <!-- <li>
          <label for="categoryFilter">UPDATION DATE</label>
          <p-dropdown
            [options]="PlatformFliters.updationDate"
            [filter]="true"
            filterPlaceholder="Search Updation Date"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.updationDate"
            (onChange)="createFilter('updationDate', $event.value)"
            placeholder="Select Updation Date"
          ></p-dropdown>
        </li> -->
      </ul>
      <div class="filter-buttons">
        <button (click)="applyFilter()">Apply Filter</button>
        <button (click)="resetFilter()">Reset Filter</button>
      </div>
    </aside>
  </div>

  <div class="pagination-container">
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="first"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [styleClass]="'custom-paginator'"
    >
    </p-paginator>

    <p class="total-pages" *ngIf="totalpages > 2">
      Total Pages: <span>{{ totalpages }}</span>
    </p>
  </div>
  <button class="back_to_top my-5" (click)="scrollToTop()">
    <img
      class="back_to_top_img"
      src="../../../assets/icons/output-onlinepngtools (5).png"
    />
  </button>
</div>
<ng-template #noResultsFound>
  <div class="no-results-container" *ngIf="searched">
    <img
      src="../../../assets/img/no-data.png"
      class="no-results-image"
      alt="No data available"
    />
    <div class="no-results-message color_black">
      <span class="font_20 weight_800"
        >Sorry – The search found zero results. Why…</span
      >
      <ul class="no-results-list text_start">
        <li>
          <span class="font_20 weight_500"
            >Make sure you have selected the correct search criteria</span
          >
        </li>
        <li>
          <span class="font_20 weight_500"
            >Make sure that all words are spelled correctly</span
          >
        </li>
        <li>
          <span class="font_20 weight_500">Try different keywords</span>
        </li>
        <li>
          <span class="font_20 weight_500">Try more general keywords</span>
        </li>
      </ul>
    </div>
    <!-- Back to search button -->
    <!-- <button class="btn-back-to-search" (click)="goBackToSearch()">
      Back to Search
    </button> -->
  </div>
</ng-template>
